<script>
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import html2pdf from 'html2pdf.js'
import Widget from './widget'

// import axios from 'axios'

export default {
	page: {
		title: '360MDR Recommendations',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: {
		Layout,
		Widget
	},
	props: {
		name: {
			type: String,
			default: 'main.json'
		}
	},
	data() {
		return {
			showDownloadButton: false,
			showGenerating: true,
			startDateTime: null,
			endDateTime: null,
			startDateTimeShow: null,
			endDateTimeShow: null,
			error: null,
			title: 'Fundación Cardio Infantil',
			spacer: '',
			startEpoch: 0,
			endEpoch: 0,
			date: null,
			dateTimePicker: {
				enableTime: true,
				dateFormat: 'm/d/Y H:i',
			},
			dashboard: {
				"widgets": [
                    {
                        "source": "/recommendations/list?withid=yes",
                        "name": "RECOMENDACIONES",
                        "cols": "col-md-12",
                        "height_class": "",
                        "component": "recommendations",
                        "card_style": "",
                        "range": true,
                        "refresh": 60000
                    }
				]
			},
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			base: 0,
			pdfConfig: {
				margin: 0.2,
				filename: 'report.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: { scale: 2, dpi: 96, letterRendering: true, width: 1280 },
				jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
				pagebreak: { mode: 'css', before: '#page2el' },
				_pageBreak: { mode: 'avoid-all', before: '.break-page', after:'.break-page'}
			},
		}
	},
	computed: {
		dateTimeFormatedRange: function () {
			let res = ''
			if (this.startDateTimeShow !== null) res += this.startDateTimeShow + ' - '
			if (this.endDateTimeShow !== null) res += this.endDateTimeShow 		
			return res
		}
	},
	mounted () {
		// this.showModal()
      	setTimeout(() => {
				this.showDownloadButton = true
				this.showGenerating = false
			}, 15000)
	},
	methods: {
		showModal() {
			this.$refs['modal-datetime'].show()
		},
		handleOk (evt) {
			let that = this
			if (that.startDateTime === null) {
				that.error = "Please select a start date and time"
				evt.preventDefault()
			} else if (that.endDateTime === null) {
				that.error = "Please select an end date and time"
				evt.preventDefault()
			} else {
				that.startEpoch = parseInt(new Date(that.startDateTime).getTime()/1000)
				that.endEpoch = parseInt(new Date(that.endDateTime).getTime()/1000)
				console.log(that.startEpoch, that.endEpoch, that.endEpoch - that.startEpoch)
				that.base += 100
				that.spacer = ' -  '
				that.error = null
				that.startDateTimeShow = that.startDateTime
				that.endDateTimeShow = that.endDateTime
				that.showDownloadButton = false
				that.showGenerating = true
				const waitTime = parseInt((that.endEpoch-that.startEpoch)/10)
				setTimeout(() => {
					that.showDownloadButton = true
					that.showGenerating = false
				}, waitTime)
			}
		},
		downloadPdf() {
			const element = document.getElementById('pdfcontent')
			html2pdf(element, this.pdfConfig)
    	},
	},
}
</script>

<template>
	<Layout>
		<div class="container" style="max-width: 1420px !important;">
			<br></br>
			<!-- <div class="row">
				<div class="col-md-12" style="text-align:center;">
					<template v-if="showDownloadButton">
						<b-button class="btn btn-primary btn-sm mr-1" variant="light" @click="downloadPdf()">
							Download PDF
						</b-button>
					</template>
					<template v-if="showGenerating">
						<span>
							Generating...
						</span>
					</template>
				</div>
			</div> -->
			<div id="pdfcontent" style="width:1280px;background-color: rgb(237, 239, 243); break-after: page; clear: both;padding-left:20px;padding-right:20px;">
				<section slot="pdf-content">
					<br><br>
					<div class="row">
						<div class="col-md-12 align-items-center" style="text-align:center">
							<h2 style="align:center;cursor:pointer;">
								{{ title }}
							</h2>
							<h4 style="align:center;cursor:pointer;" v-on:click="showModal">
								{{ dateTimeFormatedRange || 'últimas 24 horas'}}
							</h4>
						</div>
					</div>
					<div class="row">
						<template v-for="(widget, index) in dashboard.widgets">
							<Widget v-bind:key="index + base"
								:params="widget.params"
								:title="widget.name"
								:component="widget.component"
								:source="widget.source"
								:cols="widget.cols"
								:trend="widget.trend"
								:wclass="widget.class"
								:type="widget.type"
								:colors="widget.colors"
								:colorsByLabel="widget.colorsByLabel"
								:range="widget.range"
								:cardStyle="widget.card_style"
								:start="startEpoch"
								:end="endEpoch"
							/>
						</template>
						<span class="break-page" />

					</div>
				</section>
			</div>
		</div>
		<b-modal
			ref="modal-datetime"
			id="incident.incident_id"
			size="xs"
			title="Select Time Range"
			:ok-only=true
			:centered=true
			:no-fade=true
			@ok="handleOk">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>Start</label>
					<flat-pickr
						v-model="startDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>End</label>
					<flat-pickr
						v-model="endDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
			</div>
			<div v-if="error !== null" class="row">
				<div class="col-md-12 severity_high" style="text-align:center">
					{{ error }}
				</div>
			</div>

		</b-modal>
	</Layout>
</template>


